<template>
  <div>
    <v-dialog persistent @keydown.esc="closeModal"  :value="vg_create" width="500">
      <v-card>
        <v-card-title>Create a new table</v-card-title>
        <v-card-text>
          <div>
            <v-form ref="createTableForm" lazy-validation>
              <v-text-field
                v-model="form.label"
                :rules="textValidation"
                name="Lable"
                label="Lable"
                required
                validate-on-blur
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="form.slug"
                :rules="textValidation"
                name="Slug"
                label="Slug"
                required
                validate-on-blur
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="computedNumber"
                :rules="numValidation"
                name="Table Number"
                label="Table Number"
                required
                validate-on-blur
                type="number"
              ></v-text-field>
              <v-checkbox
                v-model="form.is_vacant"
                label="Is Vacant"
                type="checkbox"
              ></v-checkbox>
            </v-form>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            @click="closeModal()"
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
            style="text-transform: capitalize;"
            >Cancel</v-btn
          >
          <v-btn
            @click="add()"
            color="white"
            :class="
              $vuetify.breakpoint.width > 960
                ? 'ml-0 mr-0 primary'
                : 'ml-0 primary'
            "
            style="text-transform: capitalize;"
            >Create</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Helper from '@/utility/Helpers'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
      normalValidation: [v => !!v || 'Field is required'],
      numValidation: [v => v > 0 || 'Field should be greater than 0'],
      textValidation: [
        v => !!v || 'Field is required',
        v => Helper.validateSpace(v) || `Blank value.`
      ],
      form: {
        label: '',
        slug: '',
        is_vacant: true,
        table_number: 1
      }
    }
  },
  computed: {
    ...mapGetters({
      vg_create: 'table/isCreating'
    }),
    computedNumber: {
      get() {
        return this.form.table_number
      },
      set(val) {
        this.form.table_number = Number(val)
      }
    }
  },
  mounted() {
    /**
     * Set image
     */
    this.$root.$on('resource-selected', event => {
      if (this.addModal) {
        this.form.image = event[0].full_url
      }
    })
  },
  methods: {
    /**
     * Insert
     */
    async add() {
      if (this.$refs.createTableForm.validate()) {
        try {
          this.spinner(true)
          let res = await this.va_createTable(this.form)
          this.spinner(false)
          // Display message alert
          this.snackbar({
            text: res.data.msg,
            open: true,
            color: 'success'
          })
        } catch (err) {
          this.spinner(false)
          this.snackbar({
            text: err.response.data.payload[0].message,
            open: true,
            color: 'error'
          })
        } finally {
          this.closeModal()
          this.$refs.createTableForm.reset()
        }
      }
    },
    /**
     * Close add popup
     */
    closeModal() {
      this.va_create(false)
    },

    ...mapActions({
      va_createTable: 'table/createTable'
    }),
    ...mapMutations({
      va_create: 'table/SET_DIALOG_CREATE',
      va_setSelected: 'table/SET_SELECTED'
    })
  }
}
</script>
